<template>
  <div>
    <section class="p-4 container text-center">
      <slot></slot>
    </section>
  </div>
</template>
<script>
export default {
  name: 'DataDescription',
};
</script>
